'use client';
const ACCORDION_ERRORS_VALUE = 'Компонент Accordion.Item был добавлен в дерево с невалидным или неуказанным value.';

export { ACCORDION_ERRORS_VALUE };
//# sourceMappingURL=Accordion.errors.js.map
